import React, { useEffect, useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import { UserIcon, StarIcon, QuoteIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Testimonials = () => {
  const testimonials = [{
    id: 1,
    name: 'Dr. Oluwasegun Adeyemi',
    role: 'Alumni, Class of 2000',
    quote: 'My foundation at IGS prepared me for success in medical school and beyond. The discipline, academic rigor, and values instilled in me continue to guide my professional life as a surgeon.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    category: 'alumni'
  }, {
    id: 2,
    name: 'Mrs. Adebola Johnson',
    role: 'Parent',
    quote: "The quality of education and character development my children receive at Isonyin Grammar School is exceptional. The teachers are dedicated and the administration is responsive to parents' concerns.",
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    category: 'parent'
  }, {
    id: 3,
    name: 'Chioma Nwosu',
    role: 'Current Student, SS3',
    quote: "The opportunities at IGS are incredible. From academic competitions to leadership roles, I've grown so much as a person. The teachers genuinely care about our success and future.",
    image: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80',
    category: 'student'
  }, {
    id: 4,
    name: 'Mr. Adebayo Ogunlana',
    role: 'English Teacher',
    quote: "Teaching at IGS has been the most rewarding experience of my career. The school's commitment to academic excellence and holistic development creates an environment where both students and teachers can thrive.",
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    category: 'staff'
  }, {
    id: 5,
    name: 'Mrs. Folake Ogunleye',
    role: 'Alumni, Class of 1992',
    quote: "The values and discipline I learned at IGS have shaped my life and career. The friendships I formed during my time at the school have lasted decades, and I'm proud to see how the school continues to evolve while maintaining its core traditions.",
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=776&q=80',
    category: 'alumni'
  }, {
    id: 6,
    name: 'Oluwaseun Adebayo',
    role: 'Current Student, SS3',
    quote: "The boarding experience at IGS has taught me independence and discipline. The facilities are excellent, and the house parents are caring and supportive. I've made lifelong friends here.",
    image: 'https://images.unsplash.com/photo-1531384441138-2736e62e0919?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    category: 'student'
  }, {
    id: 7,
    name: 'Mr. & Mrs. Oluseyi',
    role: 'Parents',
    quote: "We've seen tremendous growth in our daughter since she joined IGS. The school's balanced approach to education, combining academic excellence with character development, is exactly what we were looking for.",
    image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    category: 'parent'
  }, {
    id: 8,
    name: 'Dr. Elizabeth Nwachukwu',
    role: 'Biology Teacher',
    quote: "The administration's support for innovative teaching methods has allowed me to create engaging learning experiences for my students. The laboratory facilities are well-equipped, and the students are eager to learn.",
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=776&q=80',
    category: 'staff'
  }, {
    id: 9,
    name: 'Chief Adeyemi Ogunlana',
    role: 'Community Leader',
    quote: 'Isonyin Grammar School has been a beacon of excellence in our community for decades. The school has produced leaders in various fields who continue to contribute to the development of our local area and the nation at large.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    category: 'community'
  }];
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredTestimonials, setFilteredTestimonials] = useState(testimonials);
  useEffect(() => {
    if (activeFilter === 'all') {
      setFilteredTestimonials(testimonials);
    } else {
      setFilteredTestimonials(testimonials.filter(t => t.category === activeFilter));
    }
  }, [activeFilter]);
  return <div className="min-h-screen bg-white" data-id="element-5926">
      <PageHeader title="Testimonials" description="Hear from our students, parents, alumni, and staff about their experiences at Isonyin Grammar School." backgroundImage="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Testimonials',
      path: '/testimonials'
    }]} data-id="element-5927" />
      <div className="container mx-auto px-4 py-12" data-id="element-5928">
        <div className="text-center mb-10" data-id="element-5929">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5930">
            What Our Community Says
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5931"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5932">
            Read testimonials from the people who make up our community -
            students, parents, alumni, and staff.
          </p>
        </div>
        {/* Filter buttons */}
        <div className="flex flex-wrap justify-center gap-2 mb-10" data-id="element-5933">
          <button onClick={() => setActiveFilter('all')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeFilter === 'all' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-5934">
            All Testimonials
          </button>
          <button onClick={() => setActiveFilter('student')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeFilter === 'student' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-5935">
            Students
          </button>
          <button onClick={() => setActiveFilter('parent')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeFilter === 'parent' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-5936">
            Parents
          </button>
          <button onClick={() => setActiveFilter('alumni')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeFilter === 'alumni' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-5937">
            Alumni
          </button>
          <button onClick={() => setActiveFilter('staff')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeFilter === 'staff' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-5938">
            Staff
          </button>
          <button onClick={() => setActiveFilter('community')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeFilter === 'community' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-5939">
            Community
          </button>
        </div>
        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-5940">
          {filteredTestimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-6 rounded-lg shadow-md relative" data-id="element-5941">
              <div className="absolute -top-4 -left-4 text-6xl text-yellow-500 opacity-30" data-id="element-5942">
                <QuoteIcon className="h-12 w-12" data-id="element-5943" />
              </div>
              <div className="relative z-10" data-id="element-5944">
                <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-5945">
                  {testimonial.quote}
                </p>
                <div className="flex items-center" data-id="element-5946">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-5947" />
                  <div data-id="element-5948">
                    <h4 className="font-bold text-blue-900" data-id="element-5949">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-5950">{testimonial.role}</p>
                  </div>
                </div>
                <div className="flex text-yellow-500 mt-3" data-id="element-5951">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-5952" />)}
                </div>
              </div>
            </div>)}
        </div>
        {/* Submit your testimonial section */}
        <div className="bg-blue-50 rounded-lg p-8 border border-blue-100" data-id="element-5953">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-5954">
            <div data-id="element-5955">
              <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-5956">
                Share Your Experience
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-5957">
                We'd love to hear about your experience with Isonyin Grammar
                School. Your testimonial could inspire future students and
                parents.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-5958">
                Whether you're a current student, parent, alumni, or staff
                member, your story matters to us. Share how IGS has impacted
                your life or education journey.
              </p>
              <div className="flex items-center text-gray-600 text-sm mb-6" data-id="element-5959">
                <UserIcon className="h-4 w-4 mr-2 text-blue-700" data-id="element-5960" />
                <span data-id="element-5961">
                  All testimonials are reviewed before being published
                </span>
              </div>
            </div>
            <div data-id="element-5962">
              <form className="space-y-4" onSubmit={e => {
              e.preventDefault();
              alert('Thank you for submitting your testimonial! It will be reviewed and published soon.');
            }} data-id="element-5963">
                <div data-id="element-5964">
                  <label htmlFor="name" className="block text-gray-700 font-medium mb-1" data-id="element-5965">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Your full name" required data-id="element-5966" />
                </div>
                <div data-id="element-5967">
                  <label htmlFor="role" className="block text-gray-700 font-medium mb-1" data-id="element-5968">
                    Your Relationship to IGS
                  </label>
                  <select id="role" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" required data-id="element-5969">
                    <option value="" data-id="element-5970">Select your relationship</option>
                    <option value="student" data-id="element-5971">Current Student</option>
                    <option value="parent" data-id="element-5972">Parent</option>
                    <option value="alumni" data-id="element-5973">Alumni</option>
                    <option value="staff" data-id="element-5974">Staff</option>
                    <option value="community" data-id="element-5975">Community Member</option>
                  </select>
                </div>
                <div data-id="element-5976">
                  <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-5977">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Your email address" required data-id="element-5978" />
                </div>
                <div data-id="element-5979">
                  <label htmlFor="testimonial" className="block text-gray-700 font-medium mb-1" data-id="element-5980">
                    Your Testimonial
                  </label>
                  <textarea id="testimonial" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Share your experience with Isonyin Grammar School..." required data-id="element-5981"></textarea>
                </div>
                <div className="flex items-center" data-id="element-5982">
                  <input type="checkbox" id="consent" className="h-4 w-4 text-blue-700 focus:ring-blue-500 border-gray-300 rounded" required data-id="element-5983" />
                  <label htmlFor="consent" className="ml-2 block text-sm text-gray-700" data-id="element-5984">
                    I consent to having my testimonial and name published on the
                    school website
                  </label>
                </div>
                <Button type="submit" variant="primary" data-id="element-5985">
                  Submit Testimonial
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Testimonials;